{
	"side-bar-panel-control": {
		"account": "My Account Information",
		"profile": "My Profile",
		"version": "System Version",
		"logout": "Logout",
		"password": "Password",
		"pref": "Preferences",
		"config": "Webhook Config",
		"account-page": {
			"name": "Full Name",
			"placeholder_name": "ex: Francisco Perez",
			"email": "Contact Email",
			"placeholder_email": "ex: example@mail.com",
			"type": "User Type",
			"placeholder_type": "ex: Administrator",
			"company": "Company",
			"placeholder_company": "ex: EXAMPLE COMPANY",

			"code_company": "Codigo de Compañia",
			"code_propierty": "Propierty code",
			"name_propierty": "Property Name",

			"header-2": "Your Company Information",
			"ID": "Employee ID",
			"header-3": "Master Code",
			"code": "Your Code for Today",
			"btn-generate": "Generate New Code",
			"btn": "Save Changes"
		},
		"password-page": {
			"txt-1": "If you want to change your password, enter the current one to start the process.",
			"current": "Current Password",
			"placeholder_current": "*****************",
			"new": "New Password",
			"placeholder_new": "*****************",
			"confirm": "Confirm Password",
			"placeholder_confirm": "*****************"
		},
		"preferences-page": {
			"dark-mode": "Dark Mode",
			"light-mode": "Light Mode",
			"language": "Language",
			"es": "Spanish",
			"en": "English"
		},
		"dialog": {
			"title": "Propety Code",
			"button": "Copy code"
		},
		"notifications": {
			"updateAccount": {
				"title": "Information changed",
				"subtitle": "User information has been modified."
			}
		}
	},
	"extend-package": {
	"column": "Extend",
	"action": "Extend",
	"actionAriaLabel": "Extend package for 3 days",
	"actionTooltip": "Extend package for 3 days",
	"title": "Extend package",
	"subtitle": "Confirm the action before extending the package availability period.",
	"tracking": "Tracking number",
	"resident": "Resident",
	"currentExpiration": "Current expiration",
	"newExpiration": "New expiration",
	"noticeTitle": "Fixed 3-day extension",
	"notice": "The package will be available for collection for 3 days starting now.",
	"error": "The package could not be extended. Please try again.",
	"buttons": {
		"cancel": "Cancel",
		"confirm": "Extend 3 days"
	}
},
	"buttons": {
		"resetChanges": "Reset Changes",
		"saveInformation": "Save Information",
		"saveChanges": "Save Information",
		"add_client": "Add client",
		"addService": "Add service"
	},
	"accountSettingsPage": {
		"title": "My Account",
		"switchContent": {
			"perfil": "Profile",
			"notifycations": "Notifications",
			"preferences": "Preferences"
		},
		"perfil": {
			"my-information": {
				"title": "My Information",
				"subtitle": "Thanks to this information, we can contact you if necessary, as well as for refund processes or clarifications.",
				"username": "Username",
				"placeholderUsername": "Account holder's name",
				"idEmployee": "Employee ID",
				"placeholderIDEmployee": "1324-5676",
				"email": "Email",
				"placeholder": "name@example.com",
				"telephone": "Contact Phone",
				"placeholderTelephone": "(81)1625-6549"
			},
			"password": {
				"title": "Password",
				"subtitle": "Enter your current password to create a new one.",
				"form": {
					"actual-password": "Current Password",
					"placeholder_actual": "*****************",
					"new-password": "Your New Password",
					"placeholder_newPassword": "Ex:1Qazxsw2*-",
					"boxValidation": {
						"title": "To protect your account, make sure your password has:",
						"validation1": "An uppercase letter",
						"validation2": "A number",
						"validation3": "A special character",
						"validation4": "At least 8 characters"
					},
					"confirmPassword": "Confirm Your Password",
					"placeholder_confirmPassword": "*****************",
					"btnUpdatePassword": "Update My Password"
				}
			}
		},

		"notifications": {
			"dashboard-notifications": {
				"title": "Dashboard Notifications",
				"subtitle": "Select the type of notifications you want to receive. System notifications cannot be disabled.",
				"selects": {
					"title-order": "Orders",
					"subtitle-order": "Received orders, in delivery, in locker, collected, expired, etc.",
					"title-fulfillment": "Fulfillment",
					"subtitle-fulfillment": "Products received in the warehouse, re-entries, stock reductions, and out-of-stock items.",
					"title-tickets": "Payment Tickets",
					"subtitle-tickets": "New tickets, due dates, approved or rejected payments."
				}
			},
			"dashboard-email": {
				"title": "Email Notifications",
				"subtitle": "These notifications are sent whenever something important happens with your account. Select the type of emails you want to receive.",
				"selects": {
					"title-order": "Orders",
					"subtitle-order": "Received orders, in delivery, in locker, collected, expired, etc.",
					"title-fulfillment": "Fulfillment",
					"subtitle-fulfillment": "Products received in the warehouse, re-entries, stock reductions, and out-of-stock items.",
					"title-tickets": "Payment Tickets",
					"subtitle-tickets": "New tickets, due dates, approved or rejected payments.",
					"title-surveys": "Surveys",
					"subtitle-surveys": "These surveys help us improve and offer you a better experience."
				}
			},
			"passwordChanged": {
				"title": "Password Changed",
				"subtitle": "The password has been changed"
			}
		},
		"preferences": {
			"appearance": {
				"title": "Appearance",
				"subtitle": "Customize the interface to your liking, select the primary color or the display mode.",
				"color-primary": {
					"title": "Primary Color",
					"subtitle": "This color will appear on buttons or borders."
				},
				"mode": {
					"title": "Mode",
					"light": "Light",
					"dark": "Dark"
				}
			},
			"language": {
				"title": "Language",
				"subtitle": "Customize the appearance of your application to your preference, change its primary color or the mode, either light or dark.",
				"lang": {
					"es": "Spanish",
					"en": "English"
				}
			}
		}
	},
	"loginPage": {
		"title": "Welcome",
		"subtitle": "Please enter the following information to continue.",
		"form": {
			"email": "Email",
			"placeholder_email": "name@example.com",
			"password": "Password",
			"placeholder_password": "**************",
			"checkbox": "Remember my information",
			"forgetPassword": "Forgot my password",
			"btnLogin": "Log in",
			"footer": "New to fulfillment?",
			"footerLink": "We can help you"
		},
		"alert": {
			"errorLogin": {
				"msgTitle": "It looks like there was an error",
				"msgSubtitle": "Please try again later"
			},
			"code-1202": {
				"msgTitle": "There was an error",
				"msgSubtitle": "Invalid username or incorrect password"
			}
		}
	},
	"createNewPassword": {
		"forgotPasswordForm": {
			"title": "I Forgot My Password",
			"subtitle": "Don't worry, it can happen to anyone. Enter the email associated with your account, and we'll tell you how to recover it.",
			"email": "Email",
			"recoverPassword": "Recover My Password",
			"buttonThrowback": "Return to Main Screen"
		},
		"title": "Create a New Password",
		"subtitle": "Complete the following fields to recover your account and continue shipping your products.",
		"form": {
			"labelNewPassword": "Your New Password",
			"boxValidation": {
				"title": "To protect your account, make sure your password has:",
				"validation1": "An uppercase letter",
				"validation2": "A number",
				"validation3": "A special character",
				"validation4": "At least 8 characters"
			},
			"confirmPassword": "Confirm Your Password",
			"btnUpdatePassword": "Update My Password"
		},
		"passwordChanged": {
			"title": "All set!",
			"subtitle": "We knew you'd be back. You have recovered your account and now you can continue managing your logistic network with us.",
			"subtitleApp": "We knew you would be back. You have your account back. Now close this tab and log in to the Package Hub application"
		},

		"passwordNotChanged": {
			"title": "Oops, There Was an Error!",
			"subtitle": "We're sorry for the inconvenience. Please try the password reset process again."
		},
		"oneStepMore": {
			"title": "Just One More Step...",
			"subtitle-1": "If the email",
			"subtitle-2": "is associated with an account, you will receive an email with the next steps. Be sure to check your spam or junk folder.",
			"paragraph-1": "Not sure about the email you entered?",
			"paragraph-2": "Try a different one."
		},
		"buttons": {
			"throwback-login": "Go to Main Screen",
			"updatePassword": "Update My Password",
			"sendEmail": "Resend Email",
			"returnBackLogin": "Return to Main Screen"
		},
		"notifications": {
			"emailSending": {
				"title": "Mail has been forwarded",
				"subtitle": "Check your spam or junk folder. If you still do not receive it, check that your email is spelled correctly."
			}
		}
	},
	"sidebarComponent": {
		"settings": {
			"title": "Settings",
			"languages": {
				"title": "Language",
				"es": "Spanish",
				"en": "English"
			},
			"appearance": {
				"title": "Appearance",
				"light": "Light",
				"dark": "Dark"
			}
		}
	},
	"lockerPage": {
		"title": "Lockers",
		"buttons": {
			"add_locker": "Add new locker"
		},
		"cards": {
			"cardsOrders": {
				"card-1": {
					"title": "Delivered Orders",
					"tooltip": "Total number of deliveries since the system started being used.",
					"footer": "Information not available"
				},
				"card-2": {
					"title": "Collected Orders",
					"tooltip": "Total number of collections since the system started being used.",
					"footer": "vs last month"
				},
				"card-3": {
					"title": "Orders in Locker",
					"tooltip": "Number of packages currently stored in all our lockers.",
					"footer": "vs last month"
				}
			},
			"mapCard": {
				"title": "Locations"
			}
		},
		"location": "Location",
		"input-search": "Search...",
		"filters": "Filters",
		"export": "Export",
		"table": {
			"alias": "Locker Alias",
			"location": "Location",
			"name_propierty": "Property Name",
			"totalDeliveries": "Total Deliveries",
			"doors": "Doors",
			"doorsAvailable": "Available Doors",
			"failedDoor": "Failed doors",
			"status": "Status"
		},
		"statusLocker": {
			"1": "Active",
			"2": "Inactive"
		}
	},
	"utcPage": {
		"title": "Logistics Network, UTC",
		"cards": {
			"bigCard": {
				"title": "Total Stores"
			},
			"cardsUTC": {
				"card-1": {
					"title": "Active UTCs",
					"tooltip": "Tooltip for Active UTCs",
					"footer": "Information not available"
				},
				"card-2": {
					"title": "Inactive UTCs",
					"tooltip": "Tooltip for Inactive UTCs",
					"footer": "Information not available"
				}
			},
			"cardsOrders": {
				"card-1": {
					"title": "Completed Orders",
					"tooltip": "Tooltip for Completed Orders",
					"footer": "Information not available"
				},
				"card-2": {
					"title": "Orders in Progress",
					"tooltip": "Tooltip for Orders in Progress",
					"footer": "vs last month"
				},
				"card-3": {
					"title": "Expired Orders",
					"tooltip": "Tooltip for Expired Orders",
					"footer": "vs last month"
				},
				"card-4": {
					"title": "Returned Orders",
					"tooltip": "Tooltip for Returned Orders",
					"footer": "vs last month"
				}
			},
			"mapCard": {
				"title": "Locations"
			}
		},
		"table": {
			"alias": "UTC Alias",
			"store": "Store",
			"referenceCode": "CR",
			"openingHours": "Opening Hours",
			"spacesAvailable": "Available Spaces",
			"systemStatus": "System Status"
		},
		"components": {
			"status": {
				"active": "Active",
				"inactive": "Inactive"
			}
		},
		"overlayNoContent": {
			"title": "No Results",
			"subtitle": "It looks like we couldn't find any items matching your search."
		},
		"overlayLoading": {
			"title": "Loading"
		}
	},
	"utcDetailPage": {
		"breadcrumb": {},
		"contentSwitcher": {
			"resumen": "Summary",
			"actividad": "Activity"
		},
		"cards": {
			"cardsUTC": {
				"card-1": {
					"title": "Avg. Usage vs Capacity",
					"tooltip": "Tooltip for Avg. Usage vs Capacity",
					"footer": "vs last month"
				},
				"card-2": {
					"title": "OXXO to OXXO, Local",
					"tooltip": "Tooltip for OXXO to OXXO, Local",
					"footer": "vs last month"
				},
				"card-3": {
					"title": "OXXO to OXXO, National",
					"tooltip": "Tooltip for OXXO to OXXO, National",
					"footer": "vs last month"
				},
				"card-4": {
					"title": "PUDO Partners",
					"tooltip": "Tooltip for PUDO Partners",
					"footer": "vs last month"
				}
			},
			"cardsOrders": {
				"card-1": {
					"title": "Completed Orders",
					"tooltip": "Tooltip for Completed Orders",
					"footer": "vs last month"
				},
				"card-2": {
					"title": "Expired Orders",
					"tooltip": "Tooltip for Expired Orders",
					"footer": "vs last month"
				},
				"card-3": {
					"title": "Returned Orders",
					"tooltip": "Tooltip for Returned Orders",
					"footer": "vs last month"
				},
				"card-4": {
					"title": "Total Traffic per Unit",
					"tooltip": "Tooltip for Total Traffic per Unit",
					"footer": "vs last month"
				}
			},
			"cardMap": {
				"title": "Location"
			}
		},
		"table": {
			"contentSwitcher": {
				"todas": "All Orders",
				"proceso": "In Progress",
				"expiradas": "Expired",
				"agendadas": "Scheduled",
				"completadas": "Completed",
				"canceladas": "Canceled"
			},
			"activity": {
				"orderNumber": "Order Number",
				"event": "Event",
				"dateEvent": "Event Date",
				"description": "Description"
			},
			"general": {
				"orderNumber": "Order Number",
				"model": "Model",
				"sender": "Sender",
				"addressee": "Recipients",
				"origin": "Origin",
				"destination": "Destination",
				"status": "Status",
				"last_update": "Last Update"
			},
			"orderNumber": "Order Number",
			"sender": "Sender",
			"addressee": "Recipients",
			"origin": "Origin",
			"destination": "Destination",
			"status": "Status",
			"last_update": "Last Update"
		},
		"comparments": {
			"disponible": "Available",
			"agendado": "Scheduled",
			"expirado": "Expired",
			"abierto": "Open",
			"ocupado": "Occupied",
			"defectuoso": "Defective"
		}
	},
	"lockerDetailPage": {
		"breadcrumb": {},
		"contentSwitcher": {
			"resumen": "Summary",
			"actividad": "Activity",
			"sync": "Synchronize",
			"cam": "Cameras"
		},
		"cards": {
			"cardsLocker": {
				"card-1": {
					"title": "Small Doors",
					"tooltip": "Dimensions: 8cm height, 37.5cm width, 55cm depth",
					"footer": "Available"
				},
				"card-2": {
					"title": "Medium Doors",
					"tooltip": "Dimensions: 18cm height, 37.5cm width, 55cm depth",
					"footer": "Available"
				},
				"card-3": {
					"title": "Large Doors",
					"tooltip": "Dimensions: 28cm height, 37.5cm width, 55cm depth",
					"footer": "Available"
				},
				"card-4": {
					"title": "XL Doors",
					"tooltip": "Dimensions: 47.5cm height, 37.5cm width, 55cm depth",
					"footer": "Available"
				},
				"card-5": {
					"title": "XXL Large Doors",
					"tooltip": "Dimensions: 926cm height, 546cm width, 55cm depth",
					"footer": "Available"
				},
				"card-6": {
					"title": "XXXL Large Doors",
					"tooltip": "Dimensions: 926cm height, 1092cm width, 55cm depth",
					"footer": "Available"
				}
			},
			"cardsOrders": {
				"card-1": {
					"title": "Total Deliveries (All Time)",
					"tooltip": "Tooltip for Total Deliveries (All Time)",
					"footer": "vs last month"
				},
				"card-2": {
					"title": "Total Returns (All Time)",
					"tooltip": "Tooltip for Total Returns (All Time)",
					"footer": "vs last month"
				},
				"card-3": {
					"title": "Total Deliveries (Today)",
					"tooltip": "Tooltip for Total Deliveries (Today)",
					"footer": "vs last month"
				},
				"card-4": {
					"title": "Total Returns (Today)",
					"tooltip": "Tooltip for Total Returns (Today)",
					"footer": "vs last month"
				}
			},
			"cardMap": {
				"averageCollected": "Average collection",
				"useOfLocker": "Use of locker",
				"title": "Location",
				"registerHistoric": "Historical record",
				"collected": "Collected",
				"delivered": "Delivered",
				"expired": "Expired"
			}
		},
		"table": {
			"contentSwitcher": {
				"todas": "All Orders",
				"proceso": "In Progress",
				"expiradas": "Expired",
				"agendadas": "Scheduled",
				"completadas": "Completed",
				"canceladas": "Canceled",
				"unsassigned": "Unassigned",
				"fails":"Fails"
			},
			"activity": {
				"eventId": "Event ID",
				"event": "Event",
				"name_propierty": "Property Name",
				"dateEvent": "Event Date",
				"description": "Description"
			},
			"general": {
				"tracking_number": "Tracking Number",
				"order_number": "Order Number",
				"locker_name": "Locker",
				"name_propierty": "Property name",
				"name_service": "Service\ntype",
				"email": "Email",
				"door_number": "Door",
				"status": "Status",
				"date_in_locker": "Received Date",
				"date_collected": "Collected Date",
				"date_expired": "Expiration Date",
				"generate_qr": "Generate QR"
			},
			"expired": {
				"tracking_number": "Tracking Number",
				"email": "Email",
				"name_propierty": "Property name",
				"name_service": "Service type",
				"door_number": "Door",
				"status": "Status",
				"date_in_locker": "Received Date",
				"date_expired": "Expiration Date"
			},
			"completed": {
				"tracking_number": "Tracking Number",
				"locker_name": "Locker",
				"name_propierty": "Property name",
				"name_service": "Service type",
				"email": "Email",
				"door_number": "Door",
				"status": "Status",
				"date_in_locker": "Received Date",
				"date_collected": "Collected Date",
				"rate": "Rate"
			},
			"schedule": {
				"package": "Package",
				"otp": "OTP",
				"name_propierty": "Property name",
				"name_service": "Service type",
				"email": "Email",
				"door_number": "Door",
				"size_compartment": "Size",
				"status": "Status",
				"register_date": "Registration Date"
			},
			"canceled": {
				"tracking_number": "Tracking Number",
				"nameEmploye": "Employee Who Canceled",
				"door_number": "Door",
				"name_propierty": "Property name",
				"name_service": "Service type",
				"status": "Status",
				"date_collected": "Collected Date",
				"date_cancel": "Canceled Date",
				"locker_name": "Locker"
			},
			"fails": {
				"code_service": "Service code",
				"locker_name": "Locker",
				"name_consumer": "Consumer name",
				"email": "Email",
				"position": "Door number",
				"registration_date": "Registration date",
				"update_date": "Update date"
			}
		},
		"estatus": {
			"RECOLECTADO": "Collected",
			"RETURN": "Returned",
			"ENTREGADO": "Delivered",
			"SCHEDULED": "Scheduled",
			"PENDIENTE": "Pending",
			"EXPIRED": "Expired",
			"EXTENDED": "Extended",
			"LOCKER": "In Locker",
			"CANCELED": "Canceled",
			"CANCELED_LOCKER": "Canceled In Locker",
			"CANCELED_PICKED": "Canceled Picked",
			"PASSWORD_EXPIRADO": "Password Expired",
			"ACTIVE": "Active",
			"DESACTIVE": "Inactive",
			"PackageCollected": "Package Collected",
			"PackageInLocker": "Package in Locker",
			"PackageExpired": "Package Expired",
			"Warehouse": "In Warehouse",
			"ScheduledDoor": "Scheduled Door",
			"OpenDoor": "Open Door",
			"CloseDoor": "Closed Door",
			"FailDoor": "Door Failure",
			"BusyDoor": "Occupied Door",
			"loginSuccess": "Login Success",
			"loginError": "Login Attempt",
			"useMasterCode": "Used Master Code",
			"logout": "Logout",
      "IN_TRANSIT": "In transit",
      "PENDING_VALIDATE": "Pending validation",
      "PENDING_PAYMENT": "Pending payment",
      "IN_PROGRESS": "In progress",
      "PROPERTY": "In property"
		},
		"comparments": {
			"disponible": "Available",
			"agendado": "Scheduled",
			"expirado": "Expired",
			"abierto": "Open",
			"ocupado": "Occupied",
			"defectuoso": "Defective",
			"unassigned": "Unassigned"
		},
		"camera": {
			"table": {
				"cam_name": "Camera name",
				"type": "Type",
				"format": "Format",
				"function": "Function",
				"fps": "FPS",
				"status": "Status"
			},
			"records": {
				"table": {
				"id_record": "Recording ID",
				"date_record": "Date and time",
				"duration": "Duration",
				"size": "Size",
				"actions": "Actions"
				}
			}
		},
		"synchronized": {
			"title": "Sync",
			"buttons": {
				"sync": "Synchronize"
			},
			"table": {
				"id_locker_sync_pending": "id locker synchronization pending",
				"id_type_event": "Event type",
				"event_name": "Event name",
				"registration_date": "Registration date",
				"attempt_count": "Number of attempts",
				"last_description": "Last description",
				"processed_at": "Processed",
				"is_processed": "Is processed",
				"processed": "Processed"
			}
		}
	},
	"usersPage": {
		"title": "Users",
		"table": {
			"admin": {
				"first_name": "First Name",
				"surname": "Last Name",
				"user_type": "User Type",
				"email": "User Email",
				"active_days": "Active\nDays",
				"registration_date": "Registration Date",
				"id_status": "User Status",
				"actions": "Action"
			},
			"worker": {
				"access_code": "Access\ncode",
				"first_name": "Operator's\nfirst name",
				"surname": "Operator's\nsurname",
				"email": "Email",
				"id_status": "Operator's\nstatus",
				"is_connected": "Is connected",
				"device": "Device",
				"last_activity": "Last activity",
				"geographical_location": "Geographical\nlocation",
				"battery_consumption": "Battery\nconsumption",
				"actions": "Actions"
			}
		},
		"contentSwitcher": {
			"Admin": "Admin",
			"HouseAccount": "House Account",
			"Worker": "Worker",

			"Active": "Active",
			"Desactive": "Desactive"
		},
		"buttons": {
			"createUser": "Create User"
		},
		"overloads": {
			"noRows": {
				"title": "Nothing here...",
				"subtitle": "It seems we couldn't find any items matching your search."
			},
			"loading": {
				"title": "Loading content..."
			}
		},
		"dialogs": {
			"dialogChangeStatusUser": {
				"headerTitle": "Are you sure you want to deactivate this user?",
				"subHeaderTitle": "By deactivating a user, they will lose access to the dashboard and will not be able to deliver packages to any locker. You can reactivate this user at any time.",
				"buttons": {
					"cancel": "Cancel",
					"desactivate": "Yes, I want to deactivate"
				}
			},
			"dialogEditUser": {
				"title": "Edit User",
				"editUser": {
					"title": "Add User",
					"fieldNameCompany": "Company Name",
					"fieldIdEmployee": "Employee ID",
					"fieldTypeEmployee": "User Type",
					"fieldNameEmployee": "Full Name",

					"fieldFirstNameEmployee": "Name",
					"fieldSurNameEmployee": "Lastname",

					"fieldEmail": "Email",
					"fieldPassword": "Password",
					"fieldConfirmPassword": "Confirm Password",
					"btnGeneratePassword": "Generate Password",
					"btnCancel": "Cancel",
					"btnContinue": "Continue",
					"errorFieldRequired": "Required field",
					"errorFieldPassword": "Passwords do not match",
					"errorFieldEmail": "Make sure to enter a valid email",
					"errorFieldId": "Required field. Must contain between 6 and 8 characters.",
					"passwordInfo": "The access password will be sent to the email you provided.",
					"passwordInfoCarrier": "The access password will be sent to the email: "
				}
			},
			"dialogAddUser": {
				"title": "Add User",
				"fields": {
					"user_type": "User Type",
					"first_name": "First Name",
					"surname": "Last Name",
					"email": "Email",
					"id_propierty": "Properties",
					"id_line_services": "Service Line",

					"placeholder_nameEmployee": "ex: John Smith",
					"placeholder_email": "ex: example@mail.com",
					"passwordInfo": "The access password will be sent to the email you provided."
				},
				"placeholder": {
					"user_type": "Select user role",
					"first_name": "Ex: John",
					"surname": "Ex: Doe",
					"email": "Ex: email@hotmail.com",
					"id_propierty": "Select the user's property",
					"id_line_services": "Select the service line"
				},
				"buttons": {
					"cancel": "Cancel",
					"saveUser": "Save User"
				}
			},
			"dialogEditUserWorker": {
				"title": "Edit User",
				"fields": {
					"user_type": "User Type",
					"first_name": "First Name",
					"surname": "Last Name",
					"email": "Email",
					"id_propierty": "Properties",
					"placeholder_nameEmployee": "ex: John Smith",
					"placeholder_email": "ex: example@mail.com",
					"passwordInfo": "The access password will be sent to the email you provided."
				},
				"placeholder": {
					"user_type": "Select user role",
					"first_name": "Ex: John",
					"surname": "Ex: Doe",
					"email": "Ex: email@hotmail.com",
					"id_propierty": "Select the user's property"
				},
				"buttons": {
					"cancel": "Cancel",
					"saveUser": "Save User"
				}
			},
			"worker": {
				"delete-worker": {
					"title": "Delete Operator",
					"subtitle": "Here you can delete the operator from your property. Make sure you are deleting the correct operator.",
					"buttons": {
						"cancel": "Cancel",
						"delete": "Delete Operator"
					}
				},
				"sign-out-worker": {
					"title": "Sign out Operator",
					"subtitle": "Here you can sign out the operator from your property. Make sure you are sign out the correct operator.",
					"buttons": {
						"cancel": "Cancel",
						"sign-out": "Sign out Operator"
					}
				}
			}
		},
		"cards": {
			"card-1": {
				"title": "User KPI",
				"tooltip": "User KPI Tooltip",
				"footer": "Information not available"
			},
			"card-2": {
				"title": "User KPI",
				"tooltip": "User KPI Tooltip",
				"footer": "Information not available"
			},
			"card-3": {
				"title": "User KPI",
				"tooltip": "User KPI Tooltip",
				"footer": "Information not available"
			},
			"card-4": {
				"title": "User KPI",
				"tooltip": "User KPI Tooltip",
				"footer": "Information not available"
			},
			"card-5": {
				"title": "User KPI",
				"tooltip": "User KPI Tooltip",
				"footer": "Information not available"
			},
			"card-6": {
				"title": "User KPI",
				"tooltip": "User KPI Tooltip",
				"footer": "Information not available"
			}
		},
		"alerts": {
			"userCanceled": {
				"title": "You have canceled the user creation",
				"subtitle": "Please try to create the user again."
			},
			"userDeleted": {
				"title": "You have deleted the user",
				"subtitle": "You have successfully deleted the user."
			},
			"userRepeated": {
				"title": "Has repettido al usuario",
				"subtitle": "No se ha insertado porque el usuario ya existe"
			},
			"userCreated": {
				"title": "The user has been created",
				"subtitle": "The created user will be shown in the table and can now access the dashboard."
			},
			"userNotCreated": {
				"title": "The user has not been created",
				"subtitle": "There was an error while creating the user. Please try again."
			},
			"userModified": {
				"title": "The user has been modified",
				"subtitle": "The user data has been successfully modified."
			},
			"userNotModified": {
				"title": "The user has not been modified",
				"subtitle": "The user data has not been modified."
			},
			"userDesactivate": {
				"title": "The user's account has been deactivated",
				"subtitle": "The selected user's account has been deactivated and cannot access the dashboard."
			},
			"userActivate": {
				"title": "The user's account has been activated",
				"subtitle": "The selected user's account has been activated and can now access the dashboard."
			}
		}
	},
	"clientsPage": {
		"title": "Clients",
		"detailClients": "Details clients",
		"cards": {
			"card-1": {
				"title": "Total Clients",
				"tooltip": "Total number of users since the system started being used.",
				"footer": "Information not available"
			},
			"card-2": {
				"title": "Unique Clients",
				"tooltip": "Clients who pick up orders only once.",
				"footer": "Information not available"
			},
			"card-3": {
				"title": "Recurring Clients",
				"tooltip": "Clients who pick up orders more than twice.",
				"footer": "Information not available"
			},
			"metrics": {
				"title": "Clients Metrics",
				"unique_clients": "Unique",
				"recurring_clients": "Recurring"
			}
		},
		"dialogs": {
			"delete-clients": {
				"title": "Delete Client",
				"subtitle": "Here you can delete clients from your property. Make sure it’s the correct client.",
				"buttons": {
					"cancel": "Cancel",
					"delete": "Delete Client"
				}
			},
			"change-status-client": {
				"title": "Change Client Status",
				"subtitle": "Here you can",
				"2": "activate",
				"1": "deactivate",
				"subtitle-1": "the client's access",
				"subtitle-2": "to your property.",
				"buttons": {
					"cancel": "Cancel",
					"confirm": "Confirm"
				}
			},
			"change-status-service": {
				"title": "Change Service Status",
				"subtitle": "Here you can",
				"2": "activate",
				"1": "deactivate",
				"subtitle-1": "the status of",
				"buttons": {
					"cancel": "Cancel",
					"confirm": "Confirm"
				}
			}
		},
		"metric": {
			"title": "Total Shipping Volume",
			"store": "Store",
			"locker": "Locker",
			"days": {
				"monday": "Monday",
				"tuesday": "Tuesday",
				"wednesday": "Wednesday",
				"thursday": "Thursday",
				"friday": "Friday",
				"saturday": "Saturday",
				"sunday": "Sunday"
			}
		},
		"overloads": {
			"noRows": {
				"title": "There's nothing here....",
				"subtitle": "It appears that we were unable to find any items matching your search."
			},
			"loading": {
				"title": "Loading content..."
			}
		},
		"table": {
			"user_name": "User name",
			"has_pending_payment_access":"Pending\npayment?",
			"user_unit_number": "Unit\nnumber",
			"status_user": "User\nstatus",
			"user_information": "User\ninformation",
			"monthly_usage": "Monthly\nusage",
			"total_usage": "Total usage",
			"holidays":"Holidays",


			"client_name": "Recipient",
			"email": "Email",
			"viviID": "VIVI ID",
			"telephone": "Phone",
			"reference_code": "Reference\nCode",
			"name_propierty": "Property\nName",
			"paid_packages": "Picked-up\nPackages",
			"register_date": "Registration Date",
			"status": "Client\nStatus",
			"status_service": "Service\nStatus",
			"actions": "Action",
			"pendingPayment":"Pending",
			"noPendingPayment":"Signed"
		},
		"notifications": {
			"userNotDeleted": {
				"title": "User Not Deleted",
				"subtitle": "An error occurred while trying to delete the user"
			},
			"userDeleted": {
				"title": "User Deleted",
				"subtitle": "The user has been successfully deleted from the database"
			},
			"userAdded": {
				"title": "User Added",
				"subtitle": "The user has been successfully added. The table will update instantly."
			},
			"userCanceled": {
				"title": "You canceled the new client creation",
				"subtitle": "The modal to create a new client has been closed."
			},
			"userEdited": {
				"title": "User Edited",
				"subtitle": "The user has been successfully edited. The table will update instantly."
			},
			"userNotModified": {
				"title": "User Not Modified",
				"subtitle": "User data has not been changed."
			},
			"userNotAdded": {
				"title": "User Not Added",
				"subtitle": "The user could not be added. An error occurred"
			},
			"statusChanged": {
				"title": "Status Changed",
				"subtitle": "The status has been changed. The table will update instantly"
			},
			"statusNotChanged": {
				"title": "The status has not been changed",
				"subtitle": "Failed to modify the status, the user has assigned packages"
			},
			"userAsignedToNewUnit": {
				"title": "The customer has been assigned",
				"subtitle": "Now the customer will be assigned the new unit in the property."
			}
		}
	},
	"timePicker": {
		"hour": "Hour",
		"minute": "Minute",
		"buttons": {
			"erase": "Erase",
			"cancel": "Cancel",
			"accept": "Accept"
		}
	},
	"storesPage": {
		"title": "Logistics Network, Stores",
		"tables": {
			"createStore": "Create store",
			"createStores": "Create Stores",
			"general": {
				"storeName": "Store Name",
				"storeAlias": "Store Alias",
				"storeCode": "Store Code",
				"address": "Address",
				"latitude": "Latitude",
				"longitude": "Longitude",
				"state": "State",
				"city": "City",
				"referenceCode": "CR",
				"openingHours": "Opening Hours",
				"openening_time": "Opening Time",
				"closing_time": "Closing Time",
				"packageManaged": "Packages Managed",
				"accion": "Action"
			}
		},
		"dialog": {
			"dialogCreateStore": {
				"title": "Add Store",
				"info": "Enter the following details to add a store. All fields are required.",
				"location": "Choose the store location",
				"fields": {
					"storeName": "Store Name",
					"storeAlias": "Store Alias",
					"state": "State",
					"city": "Plaza",
					"address": "Address",
					"latitud": "Latitude",
					"longitud": "Longitude",
					"codeReference": "CR",
					"capacity": "Service Capacity",
					"openingHours": "Opening Hours",
					"storeOpening": "Opening Time",
					"storeClosing": "Closing Time"
				},
				"buttons": {
					"cancel": "Cancel",
					"accept": "Accept"
				}
			},
			"dialogImportStore": {
				"fields": {
					"store": "Store",
					"storeAlias": "Store Alias",
					"codeReference": "CR",
					"state": "State",
					"plaza": "Plaza",
					"openingHours": "Opening Hours"
				}
			},
			"dialogEditStore": {
				"title": "Edit Store",
				"location": "Choose the store location",
				"fields": {
					"storeName": "Store Name",
					"storeAlias": "Store Alias",
					"state": "State",
					"city": "City",
					"address": "Address",
					"latitud": "Latitude",
					"longitud": "Longitude",
					"codeReference": "CR",
					"storeOpening": "Opening Time",
					"storeClosing": "Closing Time"
				},
				"buttons": {
					"cancel": "Cancel",
					"accept": "Accept"
				}
			},
			"dialogDeleteStore": {
				"title": "Are you sure you want to delete this store?",
				"delete": "When deleting a store, consider that:\nScheduled packages will not be able to be delivered.",
				"buttons": {
					"cancel": "Cancel",
					"accept": "Accept"
				}
			}
		},
		"buttons": {
			"createStore": "Add Store",
			"importStore": "Import Stores"
		}
	},
	"storeDetailPage": {
		"title": "Stores",
		"cards": {
			"openingTime": {
				"title": "Opening Time"
			},
			"closingTime": {
				"title": "Closing Time"
			},
			"location": {
				"title": "Location"
			}
		},
		"tables": {
			"general": {
				"tracking_number": "Tracking",
				"registration_date": "Registration Date",
				"entry_date": "Entry Date",
				"expiration_date": "Expiration Date",
				"package_status_id": "Status ID",
				"package_status": "Status",
				"volume": "Volume",
				"type": "Service Type",
				"company": "Company",
				"destination_store": "Destination Store",
				"id_courier": "Courier ID",
				"courier_name": "Courier"
			},
			"couriers": {
				"courier_name": "Courier",
				"signature_required": "Signatures Required",
				"id_status": "Status ID"
			}
		}
	},
	"overviewPage": {
		"title": "Welcome, ",
		"export": "Export",
		"heatMap": {
			"title": "Peak Usage Time",
			"categories": {
				"d1": "Monday",
				"d2": "Tuesday",
				"d3": "Wednesday",
				"d4": "Thursday",
				"d5": "Friday",
				"d6": "Saturday",
				"d7": "Sunday"
			}
		},
		"barChart": {
			"title": "Top 5 Most Used Lockers",
			"legends": {
				"use_of_locker": "Locker Usage"
			}
		},
		"barChartComparative": {
			"title": "Total Expired Packages",
			"categories": {
				"d1": "Monday",
				"d2": "Tuesday",
				"d3": "Wednesday",
				"d4": "Thursday",
				"d5": "Friday",
				"d6": "Saturday",
				"d7": "Sunday"
			},
			"legends": {
				"deliver_package": "Delivered Packages",
				"undeliver_package": "Undelivered Packages"
			}
		}
	},
	"ordersPage": {
		"title": "Orders",
		"cards": {
			"cardsOrders": {
				"card-1": {
					"title": "Total Usage",
					"footer": "Information not available",
					"tooltip": "Count of all orders delivered, collected, and returned since the system started."
				},
				"card-2": {
					"title": "Average Usage Per Hour",
					"footer": "Information not available",
					"tooltip": "Average total usage per active locker hours. Calculated based on delivered and collected orders per hour."
				},
				"card-3": {
					"title": "Peak Usage Time",
					"footer": "Information not available",
					"tooltip": "The time when the most orders are delivered and collected."
				}
			}
		},
		"metrics": {
			"title": "Order Metrics",
			"delivered": "Delivered",
			"collected": "Collected",
			"expired": "Expired"
		},
		"overloads": {
			"loading": {
				"title": "Loading content..."
			},
			"general": {
				"noRows": {
					"title": "There's nothing here...",
					"subtitle": "In this table, you will find all the orders and their current status."
				}
			},
			"inLocker": {
				"noRows": {
					"title": "There's nothing here...",
					"subtitle": "In this table, you will find orders in progress and information about them."
				}
			},
			"expired": {
				"noRows": {
					"title": "There's nothing here...",
					"subtitle": "In this table, you will find expired orders and information about them."
				}
			},
			"scheduled": {
				"noRows": {
					"title": "There's nothing here...",
					"subtitle": "In this table, you will find scheduled orders and information about them."
				}
			},
			"completed": {
				"noRows": {
					"title": "There's nothing here...",
					"subtitle": "In this table, you will find completed orders and information about them."
				}
			},
			"canceled": {
				"noRows": {
					"title": "There's nothing here...",
					"subtitle": "In this table, you will find canceled orders and information about them."
				}
			}
		},
		"tables": {
			"general": {
				"storeName": "Store Name",
				"storeAlias": "Store Alias",
				"storeCode": "Store Code",
				"address": "Address",
				"latitude": "Latitude",
				"longitude": "Longitude",
				"state": "State",
				"city": "City",
				"referenceCode": "CR",
				"openingHours": "Opening Hours",
				"openening_time": "Opening Time",
				"closing_time": "Closing Time",
				"packageManaged": "Packages Managed",
				"accion": "Action"
			}
		},
		"filters": {
			"title": "Filters",
			"status_title": "Status",
			"status": {
				"return": "Returned",
				"completed": "Completed",
				"in_locker": "In Locker",
				"expired": "Expired",
				"canceled": "Canceled",
				"cancelInLocker": "Canceled in Locker",
				"cancelWithdrawn": "Canceled Withdrawn"
			},
			"rates": {
				"0": "No rating",
				"1": "Poor",
				"2": "Bad",
				"3": "Fair",
				"4": "Good",
				"5": "Excellent"
			},
			"rate_title": "Rating"
		},
		"estatus": {
			"RECOLECTADO": "Collected",
			"RETURN": "Returned",
			"ENTREGADO": "Delivered",
			"SCHEDULED": "Scheduled",
			"PENDIENTE": "Pending",
			"EXPIRED": "Expired",
			"EXTENDED": "Extended",
			"LOCKER": "In Locker",
			"CANCELED": "Canceled",
			"PROPERTY": "In property",
			"CANCELED_LOCKER": "Canceled in Locker",
			"CANCELED_PICKED": "Canceled Withdrawn",
			"PASSWORD_EXPIRADO": "Password Expired",
			"ACTIVE": "Active",
			"DESACTIVE": "Inactive",
			"PackageCollected": "Package Collected",
			"PackageInLocker": "Package in Locker",
			"PackageExpired": "Package Expired",
			"Warehouse": "In Warehouse",
			"ScheduledDoor": "Scheduled Door",
			"OpenDoor": "Door Open",
			"CloseDoor": "Door Closed",
			"FailDoor": "Door Failed",
			"BusyDoor": "Door Busy",
			"loginSuccess": "Login Success",
			"loginError": "Login Attempt",
			"useMasterCode": "Used Master Code",
			"logout": "Logout",
      "IN_TRANSIT": "In transit",
      "PENDING_VALIDATE": "Pending validation",
      "PENDING_PAYMENT": "Pending payment",
      "IN_PROGRESS": "In progress"
		},
		"notifications": {
			"assignedNewAddresee": {
				"title": "The package has been assigned to the new user",
				"subtitle": "The expiration date has been updated and mail will be sent to the new user."
			}
		}
	},
	"dialogToUploadFile": {
		"title": "Import Clients",
		"subtitle": "Check that the data of the clients you want to enter is correct. This is not a final action; you can manually edit the store values individually once they have been registered.",
		"table": {
			"name": "Name",
			"lastname": "Last Name",
			"email": "Email",
			"telephone": "Phone",
			"isAccepted": "Status",
			"location": "Type\nof Location",
			"reference": "Reference",
			"unity": "Unidad"
		},
		"buttons": {
			"addUsers": "Add Clients",
			"cancel": "Cancel"
		},
		"error": {
			"title": "There was an error",
			"subtitle": "The data has not been registered. You will soon see details about why the clients were not added.",
			"buttons": {
				"close": "Close"
			}
		}
	},
	"menu": {
		"orders": "Orders",
		"appearance": "Appearance",
		"lang": "Language",
		"light": "Light",
		"dark": "Dark",
		"integrations": "Integrations",
		"version": "System Version",
		"profile": "Profile",
		"account": "My Account",
		"routes": "Routes",
		"request": "Requests",
		"inventory": "Client Inventory",
		"locker_tolocker": "Locker to Locker",
		"add_orders": "Enter Orders",
		"fullfillment": "Fullfillment",
		"incidents": "Incidents",
		"partners": "PUDO Partners",
		"transporter": "Carrier",
		"subscriptions": "Subscriptions",
		"units": "Units"
	},
	"settings": {
		"profile": "My Profile",
		"integrations": "Integrations",
		"webhook": "Webhook Configuration",
		"version": "System Version",
		"logout": "Logout"
	},
	"page403": {
		"title": "Error 403",
		"subtitle": "Access Denied",
		"paragraph": "It seems you don't have permission to view this page. Please try accessing again, and if the error persists, feel free to contact us. We will help you resolve it."
	},
	"page404": {
		"title": "Error 404",
		"subtitle": "Page Not Found",
		"paragraph": "We're sorry we couldn't find what you were looking for. Please try refreshing the page or go back to the homepage."
	},
	"page500": {
		"title": "Error 500",
		"subtitle": "Page Not Available",
		"paragraph": "It seems we've encountered an issue, but don't worry. Please try refreshing the page or go back to the homepage."
	},
	"page503": {
		"title": "Error 503",
		"subtitle": "This service is not available",
		"paragraph": "The service you are trying to access is currently unavailable. Please try refreshing the page or go back to the homepage."
	},
	"navbar": {
		"overview": "Overview",
		"locker": "Locker",
		"worker": "Worker",
		"orders": "Orders",
		"return": "Returns",
		"carrier": "Carriers",
		"users": "Users",
		"clients": "Clients",
		"welcome": "Welcome back",
		"company": "Company",
		"profile": "Profile",
		"stores": "Stores",
		"panel": "Dashboard",
		"account": "Account",
		"oxxo_to_oxxo": "OXXO to OXXO",
		"active_routes": "Active Routes",
		"lang": "Language",
		"appearance": "Appearance",
		"integrations": "Integrations",
		"version": "System Version",
		"webhook": "Webhook Settings",
		"myaccount": "My Account",
		"es": "Spanish",
		"en": "English",
		"dark": "Dark Mode",
		"light": "Light Mode",
		"log-package": "Package Audit",
		"property": "Properties"
	},
	"month": {
		"Ene": "Jan",
		"Feb": "Feb",
		"Mar": "Mar",
		"Abr": "Apr",
		"May": "May",
		"Jun": "Jun",
		"Jul": "Jul",
		"Ago": "Aug",
		"Sep": "Sep",
		"Oct": "Oct",
		"Nov": "Nov",
		"Dic": "Dec"
	},
	"uploadDocument": {
		"buttonLabel": "Upload clients",
		"popupTitle": "Import your client data",
		"popupSubtitle": "You can upload a file with your client data. If you don't have a file in the correct format yet, you can download a template",
		"popupLink": "by clicking here.",
		"fileUploader": {
			"link": "Click here",
			"clickHere": " to open your file explorer and select the file to import.",
			"fileSizeLimit": "The file you upload cannot be larger than 10MB."
		},
		"fileUpload": {
			"fileName": "{{this.file.name}}",
			"fileSize": "{{ (this.file.size / 1024 / 1024).toFixed(2) }} MB",
			"progress": "{{this.progress}}%"
		},
		"errors": {
			"fileSizeOver": "It seems the file you are trying to upload is larger than 10MB. Please check and try again.",
			"invalidFileType": "The file type is not valid. Only Excel files (csv or xls extension) are allowed.",
			"invalidHeaders": "The file does not contain the required headers: Name, Last Name, Email, Phone."
		},
		"alert": {
			"text": "Users created",
			"subtitle": "The users have been created"
		}
	},
	"notifications": {
		"title": "Notifications",
		"checkItAll": "Mark all as read",
		"button": "View activity",
		"switchContent": {
			"orders": "Orders",
			"users": "Users",
			"all": "All"
		},
		"buttons": {
			"close": "Close",
			"notifyActivity": "Notification activities"
		},
		"empty": {
			"title": "There's nothing here",
			"subtitle": "Here you'll find your notifications for packages or operational issues."
		},
		"items": {
			"packet": "The package",
			"user": "The user",
			"statusTopic": {
				"4": "has logged in at",
				"5": "has logged out at",
				"6": "has encountered an error at",
				"7": "has attempted to log in at",
				"8": "was picked up at",
				"9": "was delivered at",
				"10": "used the master code at",
				"11": "expired at",
				"14": "was returned to",
				"25": "was entered at",
				"26": "was assigned to",
				"27": "is in transit from the origin CEDIS",
				"28": "is at the origin CEDIS",
				"29": "is in transit to the destination CEDIS",
				"30": "is at the destination CEDIS",
				"31": "is in transit to",
				"32": "is being inspected at the CEDIS",
				"33": "was inspected",
				"34": "was confiscated",
				"35": "is located at",
				"36": "was delivered",
				"37": "expired at",
				"38": "was picked up from",
				"39": "was picked up by the customer",
				"40": "is in the process of returning to origin",
				"41": "was returned to the original customer",
				"42": "has entered legal proceedings"
			},
			"ago": "Ago",
			"minutes": "minutes",
			"hours": "hours",
			"days": "days",
			"months": "months",
			"years": "years"
		}
	},
	"systemVersionPage": {
		"title": "System Version",
		"table": {
			"version": "version",
			"date": "date",
			"json": "View Json"
		}
	},
	"orderDetail": {
		"title-orderDetail": "Order Details",
		"subtitle-informationGeneral": "General Information",
		"timeline": "Timeline",
		"informationGeneral": {
			"trackingNumber": "Tracking Number",
			"otpValidation": "OTP",
			"orderNumber": "Order Number",
			"emailClient": "Client's Email",
			"phoneClient": "Client's Phone",
			"nameEmployee": "Employee's Name",
			"numberOfDoor": "Door Number",
			"orderStatus": "Order Status",
			"typeDelivery": "Delivery Type",
			"inLocker": "Received in Locker",
			"scheduledDate": "Scheduled Date",
			"expirationDate": "Expiration Date",
			"cancelDate": "Cancellation Date",
			"removedLocker": "Removed from Locker",
			"deliverDate": "Delivery Date",
			"qualificationClient": "Client's Rating"
		},
		"subtitle-accessQR": "Access QR",
		"qrAccess": {
			"btnDownload": "Download"
		},
		"subtitleReminder": "Reminders",
		"Reminder": {
			"addReminder": "Add Reminder",
			"noReminder": "The reminders you add will appear here."
		},
		"subtitleEvidence": "Delivery Evidence",
		"Evidence": {
			"signEvidence": "Signature",
			"recollectionEvidence": "Pick-up Photo"
		},
		"eraseOrder": "Delete Order"
	},
	"estatus": {
		"RECOLECTADO": "Collected",
		"RETURN": "Returned",
		"ENTREGADO": "Delivered",
		"SCHEDULED": "Scheduled",
		"PENDIENTE": "Pending",
		"EXPIRED": "Expired",
		"EXTENDED": "Extended",
		"LOCKER": "In Locker",
		"CANCELED": "Canceled",
		"CANCELED_LOCKER": "Canceled In Locker",
		"CANCELED_PICKED": "Canceled Picked",
		"PASSWORD_EXPIRADO": "Password Expired",
		"ACTIVE": "Active",
		"DESACTIVE": "Inactive",
		"PackageCollected": "Package Collected",
		"PackageInLocker": "Package in Locker",
		"PackageExpired": "Package Expired",
		"Warehouse": "In Warehouse",
		"ScheduledDoor": "Scheduled Door",
		"OpenDoor": "Open Door",
		"CloseDoor": "Closed Door",
		"FailDoor": "Door Failure",
		"BusyDoor": "Door Occupied",
		"loginSuccess": "Login Success",
		"loginError": "Login Attempt",
		"useMasterCode": "Master Code Used",
		"logout": "Logout"
	},
	"companyPage": {
		"title": "Company",
		"add_company": "Add Company",
		"cards": {
			"card-1": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-2": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-3": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-4": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			}
		},
		"buttons": {
			"add_company": "Add Company",
			"save": "Save"
		},
		"forms": {
			"company": {
				"email": "Email",
				"placeholder_email": "example@mail.com",
				"password": "Password",
				"placeholder_password": "**************",
				"company_name": "Company Name",
				"placeholder_company_name": "Example Company",
				"trfc": "RFC",
				"placeholder_trfc": "ABCD010199AA1",
				"phone_number": "Phone Number",
				"placeholder_phone_number": "8111234567",
				"acronym": "Acronym",
				"placeholder_acronym": "EXAMPLE",
				"copyright": "Copyright",
				"placeholder_copyright": "Example SA de CV",
				"address": "Address",
				"placeholder_address": "Select a location on the map",
				"latitud": "Latitude",
				"placeholder_latitud": "25.726532603330796",
				"longitud": "Longitude",
				"placeholder_longitud": "-100.4173968080368",
				"city": "City",
				"placeholder_city": "Select city",
				"state": "State",
				"placeholder_state": "Select state",
				"selectLocation": "Select company location"
			},
			"branchs": {
				"email": "Email",
				"placeholder_email": "example@mail.com",
				"password": "Password",
				"placeholder_password": "**************",
				"name_propierty": "Property Name",
				"placeholder_name_propierty": "Property Name",
				"description": "Description",
				"placeholder_description": "Property Description",
				"address": "Address",
				"placeholder_address": "Select a location on the map",
				"city": "City",
				"placeholder_city": "Select city",
				"state": "State",
				"placeholder_state": "Select state",
				"latitude": "Latitude",
				"placeholder_latitude": "25.726532603330796",
				"longitude": "Longitude",
				"placeholder_longitude": "-100.4173968080368",

				"selectLocation": "Select property location",
				"selectLocationService": "Select service location"
			}
		},
		"table": {
			"company_name": "Company Name",
			"address": "Address",
			"trfc": "RFC",
			"company_type": "Company Type",
			"latitude": "Latitude",
			"longitude": "Longitude",
			"accion": "Action",
			"acronym": "Acronym",
			"copyright": "Copyright",
			"phone_number": "Phone Number",
			"email": "Email",
			"status": "Status",
			"registration_date": "Registration Date"
		},
		"branchTable": {
			"name_propierty": "Property name",
			"address": "Address",
			"line_service": "Type of service",
			"description": "Description",
			"city": "City",
			"state": "State",
			"by_contract": "By contract?",
			"latitud": "Latitude",
			"longitud": "Longitude"
		},
		"pages": {
			"packages": {
				"contentSwitcher": {
					"all": "All",
					"process": "In process",
					"expired": "Expired",
					"scheduled": "Scheduled",
					"completed": "Completed",
					"canceled": "Canceled"
				},
				"table": {
					"fields": {
						"tracking_number": "Order_number",
						"locker_name": "Locker",
						"name_service": "service_type",
						"email": "Mail",
						"door_number": "Door",
						"status_name": "Status",
						"package_delivery_date": "Date received",
						"package_pickup_date": "package_pickup_date",
						"code_service": "Service_code",
						"otp": "OTP",
						"compartment_name": "Compartment_name",
						"update_date": "Update_date"
					}
				}
			}
		}
	},
	"companyDetailPage": {
		"breadcrumb": {
			"superUser": {
				"company": "Company"
			},
			"admin": {
				"property": "Properties"
			}
		},
		"cards": {
			"card-1": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-2": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-3": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-4": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"bigCard": {
				"title": "Properties"
			}
		},
		"tableProperty": {
			"name_propierty": "Property Name",
			"address": "Address",
			"description_place": "Description",
			"code_propierty": "Property\nCode",
			"registration_date": "Registration Date",
			"update_date": "Update Date"
		},
		"buttons": {
			"createProperty": "Create Property"
		}
	},
	"propertyDetailPage": {
		"cards": {
			"card-1": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-2": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-3": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			},
			"card-4": {
				"title": "Pending KPI",
				"footer": "Information not available",
				"tooltip": "Tooltip for Pending KPI."
			}
		},
		"tableServices": {
			"name_propierty_unit": "Service Name",
			"line_service_name": "Service Type",
			"city": "City",
			"state_name": "State",
			"country_name": "Country",
			"address": "Address",
			"allow_signature": "Allow signature",
			"enable_carrier_passcode": "Enable carrier\ncode",
			"enable_lsa_webcam_photo": "Allow LSA\nwebcam photo"
		},
		"buttons": {
			"createProperty": "Create Property"
		}
	},
	"addLineServicePage": {
		"company": "Company",
		"addService": "Add service",
		"addProperty": "Add property",
		"subtitle": "Here you can add services for your property. Please fill in all required fields.",
		"forms": {
			"name_propierty_unit": "Property Name",
			"placeholder_name_propierty_unit": "Example of Property",
			"city": "City",
			"placeholder_city": "Select city",
			"state": "State",
			"placeholder_state": "Select state",
			"address": "Address",
			"placeholder_address": "Select a location from the map",
			"latitude": "Latitude",
			"placeholder_latitude": "25.726532603330796",
			"longitude": "Longitude",
			"placeholder_longitude": "-100.4173968080368",
			"id_line_service": "Type of service",
			"placeholder_id_line_service": "Select of service",

			"locker": "Locker",
			"placeholder_locker": "Select locker"
		}
	},
	"addClientDialog": {
		"headerContainer": {
			"title": "Add Client",
			"subtitle": "Please enter the following information to register the client"
		},
		"bodyContainer": {
			"dialog": {
				"fields": {
					"first_name": "First Name",
					"surname": "Last Name",
					"email": "Email",
					"telephone": "Phone",
					"id_propierty": "Property",
					"reference_code": "Reference",
					"sobriquet": "Location Type",
					"id_unit": "Unit",
					"id_type_consumer": "Consumer type"
				},
				"placeholder": {
					"first_name": "Ex: John",
					"surname": "Ex: Smith Doe",
					"email": "Ex: email@hotmail.com",
					"telephone": "Ex: 8117616451",
					"id_propierty": "Select a property from the list",
					"reference_code": "Apartment, House or Employee Number",
					"sobriquet": "Select a type of property",
					"id_unit": "Select the unity of client",
					"id_type_consumer": "Select type of consumer"
				}
			}
		}
	},
	"notificationDetails": {
		"title": "Notifications",
		"table": {
			"sending_number": "Sending Number",
			"description": "Description",
			"locker_name": "Locker",
			"order_number": "Order Number",
			"id_topic_audit": "Status",
			"registration_date": "Registration Date"
		},
		"status": {
			"status_1": "Updated",
			"status_2": "Deleted",
			"status_3": "Registered",
			"status_4": "Login",
			"status_5": "Package Picked Up",
			"status_6": "Package Delivered",
			"status_7": "Entered in Locker",
			"status_8": "Package Pickup",
			"status_9": "Package Delivery",
			"status_10": "Master Code Usage",
			"status_11": "Expired Package",
			"status_12": "Scheduled",
			"status_13": "Sent to Webhook",
			"status_14": "Refund",
			"status_15": "Door Opened",
			"status_16": "Door Closed",
			"status_17": "Door Failure",
			"status_18": "Door Occupied",
			"status_19": "Login Error",
			"status_20": "Employee Password Expired",
			"status_21": "Error Using Employee Master Code",
			"status_22": "Test Application Access",
			"status_23": "Test Application Access Error",
			"status_24": "Scheduled Packages Update",
			"status_25": "In Locker",
			"status_26": "Assigned",
			"status_27": "In Transit - Origin CEDIS",
			"status_28": "At Origin CEDIS",
			"status_29": "In Transit - Destination CEDIS",
			"status_30": "At Destination CEDIS",
			"status_31": "In Transit - Destination Locker",
			"status_32": "Under Review",
			"status_33": "Reviewed",
			"status_34": "Arrested",
			"status_35": "At Destination Locker",
			"status_36": "Delivered",
			"status_37": "Expired",
			"status_38": "Picked Up",
			"status_39": "Picked Up by Customer",
			"status_40": "In Process of Returning to Origin",
			"status_41": "Returned",
			"status_42": "Legal Process",
			"status_43": "Failed Attempt to Visit a Locker",
			"status_44": "Manual System Login Attempt",
			"status_45": "Badge System Login Attempt",
			"status_46": "Successful Login",
			"status_47": "Locker Backend Started",
			"status_48": "ERROR: Circuit Board Not Installed",
			"status_49": "ERROR: Module Not Configured",
			"status_50": "ERROR: Failed to Configure USB Port on Circuit Board",
			"status_51": "Restarting Locker Backend",
			"status_52": "Attempt Log for Tracking Validation",
			"status_53": "Screenshot Taken",
			"status_54": "Start Locker Backend in Virtual Mode",
			"status_55": "OXXOWAY Query",
			"status_56": "OXXOWAY Payment",
			"status_57": "OXXOWAY Reversal",
			"status_58": "OXXOWAY Error",
			"status_59": "Service not used",
			"status_60": "Service of payment expired",
			"status_61": "",
			"status_62": "",
			"status_63": "",
			"status_64": "",
			"status_65": "",
			"status_66": "",
			"status_67": "",
			"status_68": "",
			"status_69": "",
			"status_70": ""
		}
	},
	"alerts": {
		"code-1202": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Invalid username or incorrect password"
		},
		"code-1500": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Duplicate data found"
		},
		"code-1501": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Unexpected error in server response"
		},
		"code-": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Unexpected error in server response"
		},
		"code-1502": {
			"msgTitle": "An error occurred",
			"msgSubtitle": "Error saving the company and branches"
		}
	},
	"change-person-to-deliver": {
		"title": "Update addressee",
		"subtitle": "A mistake has been made in assigning this package. Don't worry, find the correct recipient in the list below and update the record. Upon doing so, the corresponding notifications will be sent to the selected addressee.",
		"placeholder-input": "Enter the customer's name or VIVI-ID",
		"buttons": {
			"cancel": "Cancel",
			"updateClient": "Update addressee"
		}
	},

	"transporterPage": {
		"title": "Carrier",
		"buttons": {
			"add_carrier": "Add carrier"
		},
		"cards": {
			"card-1": {
				"title": "Total registered carriers",
				"footer": "Information not available",
				"tooltip": "Total number of carriers in the system."
			},
			"card-2": {
				"title": "Total active carriers",
				"footer": "Information not available",
				"tooltip": "Carriers with recent activity or enabled in the system."
			},
			"card-3": {
				"title": "Total inactive carriers",
				"footer": "Information not available",
				"tooltip": "Carriers that have not made deliveries within a certain period."
			}
		},
		"dialog": {
			"dialogEditCarrier": {
				"title": "Carrier Edition",
				"subtitle": "Enable editing of carriers from the dashboard",
				"fields": {
					"full_name": "Full name",
					"alias": "Carrier alias",
					"logo": "Logo",
					"type_carrier": "Carrier type",
					"placeholder": {
						"full_name": "Enter the carrier's full name",
						"alias": "Enter a carrier alias",
						"type_carrier": "Select a carrier type"
					}
				},
				"buttons": {
					"save": "Save",
					"cancel": "Cancel",
					"resetChanges": "Reset changes"
				}
			},
			"dialogAddCarrier": {
				"title": "Carrier registration",
				"subtitle": "Allowing manual registration of carriers from the dashboard",
				"fields": {
					"full_name": "Full name",
					"alias": "Carrier alias",
					"logo": "Logo",
					"type_carrier": "Carrier type",
					"placeholder": {
						"full_name": "Enter the carrier's full name",
						"alias": "Enter a carrier alias",
						"type_carrier": "Select a carrier type",
						"logo_click": "Click here",
						"logo_span": "to open your file explorer."
					}
				},
				"buttons": {
					"save": "Save",
					"cancel": "Cancel",
					"resetChanges": "Reset changes"
				}
			},
			"dialogDeleteCarrier": {
				"title": "Delete carrier",
				"subtitle": "Here you can delete carriers. Make sure to select the correct carrier before deleting.",
				"buttons": {
					"cancel": "Cancel",
					"delete": "Delete carrier"
				},
				"messages": {
					"correctlyRemoved": {
						"text1": "Carrier",
						"text2": "has been correctly deleted",
						"subtitle": "The table will be reloaded when the process is closed"
					},
					"notCorrectlyRemoved": {
						"text1": "Carrier",
						"text2": "not has been deleted",
						"subtitle": "please try again later"
					}
				}
			},
			"dialogChangeStatusCarrier": {
				"headerTitle": "Are you sure you want to deactivate this carrier?",
				"subHeaderTitle": "By deactivating the carrier, it will lose access and will not be able to deliver packages to any locker. You can re-activate this carrier at any time.",
				"buttons": {
					"cancel": "Cancel",
					"deactivate": "Yes, I want to deactivate it",
					"activate": "Yes, I want to activate it"
				}
			}
		},
		"table": {
			"courier_name": "Full name",
			"alias_courier": "Carrier alias",
			"logo_courier_small": "Logo",
			"name_courier_type": "Carrier type",
			"code_to_deliver": "Access code",
			"actions": "Actions",
			"id_status": "Carrier status"
		},
		"charts": {
			"totalCarrierPerType": {
				"title": "Total carriers by type"
			},
			"busiestCarrier": {
				"title": "Most active carrier"
			},
			"transporterWithLessActivity": {
				"title": "Least active carrier"
			},
			"averageOrdersDeliveredPerCarrier": {
				"title": "Average orders delivered per carrier"
			}
		}
	},
	"transporterDetailPage": {
		"breadcrumb": {
			"lastPage": "Transporter"
		},
		"buttons": {
			"createReport": "Generate Report"
		},
		"cards": {
			"card-1": {
				"title": "Total Packages Delivered",
				"footer": "Information not available",
				"tooltip": "Total number of packages registered in the system."
			},
			"card-2": {
				"title": "Total Packages Available for Pickup",
				"footer": "Information not available",
				"tooltip": "Packages not yet picked up by tenants or employees."
			},
			"card-3": {
				"title": "Packages Picked Up",
				"footer": "Information not available",
				"tooltip": "Packages that have been successfully collected."
			},
			"card-4": {
				"title": "Expired Packages",
				"footer": "Information not available",
				"tooltip": "Number of packages not picked up within the time limit."
			},
			"card-5": {
				"title": "Average Package Retention Time",
				"footer": "Information not available",
				"tooltip": "Time it takes for a package to be picked up from its arrival."
			},
			"card-6": {
				"title": "Average Package Registration Time",
				"footer": "Information not available",
				"tooltip": "Time it takes for a transporter to complete the registration of a package."
			},
			"card-7": {
				"title": "Average Packages Delivered per Visit",
				"footer": "Information not available",
				"tooltip": "Average number of packages a transporter delivers in each visit."
			}
		},
		"charts": {
			"quantityOfDeliverByMounth": {
				"title": "Quantity of delivers per month",
				"months": {
					"Jan": "Jan",
					"Feb": "Feb",
					"Mar": "Mar",
					"Apr": "Apr",
					"May": "May",
					"Jun": "Jun",
					"Jul": "Jul",
					"Aug": "Aug",
					"Sep": "Sep",
					"Oct": "Oct",
					"Nov": "Nov",
					"Dec": "Dec"
				}
			},
			"totalPackageDelivered": {
				"title": "Total packages delivered",
				"locker": "Delivered to the locker",
				"operator": "Delivered to the operator"
			},
			"rateOfDeliveredVsOverduePackages": {
				"title": "Rate of delivered vs overdue packages",
				"deliver": "Delivered",
				"expired": "Expired"
			}
		},
		"table": {
			"tracking_number": "Tracking\nNumber",

			"full_name_recipient": "Recipient",
			"full_name": "Name",
			"description_income_option": "Reason",
			"status_package": "Status",
			"package_pickup_date": "Pickup\ndate",

			"locker_name": "Locker",
			"name_propierty": "Property\nName",
			"name_service": "Service\nType",
			"email": "Email",
			"door_number": "Door",
			"status_name": "Status",
			"package_delivery_date": "Received\nDate",
			"date_collected": "Collected\nDate",
			"registration_date_expired": "Expiration\nDate",
			"update_date": "Canceled Date",
			"size": "Size",
			"registration_date": "Registration\nDate",
			"otp": "OTP",
			"rate": "Rating",
			"name_employee": "User Who Canceled"
		},
		"overlays": {
			"noContentGeneral": {
				"title": "There's nothing here...",
				"subtitle": "In this table, you will find all orders and their current status."
			},
			"noContentProcess": {
				"title": "There's nothing here...",
				"subtitle": "In this table, you will find orders in process and information about them."
			},
			"noContentExpired": {
				"title": "There's nothing here...",
				"subtitle": "In this table, you will find expired orders and information about them."
			},
			"noContentScheduled": {
				"title": "There's nothing here...",
				"subtitle": "In this table, you will find scheduled orders and information about them."
			},
			"noContentCompleted": {
				"title": "There's nothing here...",
				"subtitle": "In this table, you will find completed orders and information about them."
			},
			"noContentCanceled": {
				"title": "There's nothing here...",
				"subtitle": "In this table, you will find canceled orders and information about them."
			},
			"noContentActivity": {
				"title": "There's nothing here...",
				"subtitle": "In this table, you will find locker activity and information about it."
			},
			"noData": {
				"title": "No results",
				"subtitle": "It looks like we couldn't find any items matching your search."
			}
		}
	},
	"workerPage": {
		"title": "Worker",
		"cards": {
			"card-1": {
				"title": "Delivered Packages",
				"footer": "Information not available",
				"tooltip": "Number of packages the Worker has received."
			},
			"card-2": {
				"title": "Collected Packages",
				"footer": "Information not available",
				"tooltip": "Number of packages the Worker has given to the tenant."
			},
			"card-3": {
				"title": "Packages Stored by the Worker",
				"footer": "Information not available",
				"tooltip": "Number of packages currently stored by the Worker."
			},
			"card-4": {
				"title": "Expired Packages",
				"footer": "Information not available",
				"tooltip": "Number of packages that have been removed by the Worker."
			}
		},
		"table": {
			"order_number": "Order\nNumber",
			"worker": "Worker",
			"recipient": "Recipient",
			"status": "Status",
			"package_delivery_date": "Received\nDate",
			"date_collected": "Collected\nDate",
			"delivery_reason": "Delivery Reason",
			"property": "Property",
			"carrier": "Carrier"
		}
	},
	"common": {
		"no_data_available": "No data"
	},
	"StatusPackage": {
		"status_1": "Active",
		"status_2": "Inactive",
		"status_3": "Blocked",
		"status_4": "Open",
		"status_5": "Closed",
		"status_6": "Failing",
		"status_7": "Repaired",
		"status_8": "Pending",
		"status_9": "Processed",
		"status_10": "Voided",
		"status_11": "Pending",
		"status_12": "Pending payment",
		"status_13": "Paid",
		"status_14": "Available",
		"status_15": "In process",
		"status_16": "Delivered",
		"status_17": "Assigned",
		"status_18": "Used",
		"status_19": "Blocked",
		"status_20": "Deleted",
		"status_21": "Sent",
		"status_22": "Reminder",
		"status_23": "Failed to send",
		"status_24": "Occupied",
		"status_25": "Pending payment",
		"status_26": "Paid",
		"status_27": "Installed",
		"status_28": "In stock",
		"status_29": "Assigned",
		"status_30": "Voided",
		"status_31": "Returned",
		"status_32": "Expired",
		"status_33": "Collected",
		"status_34": "Password expired",
		"status_35": "Scheduled",
		"status_36": "Scheduled",
		"status_37": "In process",
		"status_38": "Not approved",
		"status_39": "Pending payment",
		"status_40": "Completed",
		"status_41": "Cancelled",
		"status_42": "Pending approval",
		"status_43": "Approved",
		"status_44": "To update",
		"status_45": "Cancelled due to payment",
		"status_46": "Cancelled without use",
		"status_47": "In locker",
		"status_48": "Assigned",
		"status_49": "In transit from origin CEDIS",
		"status_50": "At origin CEDIS",
		"status_51": "In transit to destination CEDIS",
		"status_52": "At destination CEDIS",
		"status_53": "In transit to destination locker",
		"status_54": "Under review",
		"status_55": "Return required",
		"status_56": "Confiscated",
		"status_57": "In destination locker",
		"status_58": "Delivered",
		"status_59": "Expired",
		"status_60": "Collected expired",
		"status_61": "Collected at destination CEDIS",
		"status_62": "Returned to origin",
		"status_63": "Collected at origin CEDIS",
		"status_64": "Legal process",
		"status_65": "Blocked",
		"status_66": "Expired assigned",
		"status_67": "At CEDIS waiting for pickup",
		"status_68": "Returned",
		"status_69": "At property",
		"status_70": "Available at property",
		"status_72": "Processing payment"
	},
	"order_detail": {
		"breadcrumb": {
			"orders": "Orders",
			"carriers": "Carrier",
			"workers": "Worker",
			"detail_locker": "Locker Detail"
		},
		"buttons": {
			"sendEmail": "Resend notifications"
		},
		"notifications": {
			"both": {
				"title": "Notifications Sent",
				"subtitle": "The user will receive notifications via email and in the app."
			},
			"email": {
				"title": "Notifications Sent",
				"subtitle": "The user will receive notifications via email."
			},
			"push": {
				"title": "Notifications Sent",
				"subtitle": "The user will receive notifications in the app."
			}
		},
		"historic": {
			"title": "Order History",
			"timeline": {
				"SCHEDULED": "New order scheduled",
				"CANCELED_UNUSED": "Order canceled without use",
				"IN_LOCKER": "Order available for pickup",
				"IN_PROPIERTY": "Order available for pickup",
				"EXPIRED": "Order has expired",
				"PICKUPPACKAGE": "Order completed"
			},
			"deliver_process": {
				"title": "Delivery Process",
				"scheduled_date": "Scheduled in locker",
				"deliver_date": "Delivered to locker",
				"collect_date": "Collected from locker",
				"qualification": "Rating",
				"not_available": "Not available",
				"evidence_collected": "Evidence Collected",
				"evidence_pickup": "Evidence Pickup",
				"evidence": "Evidence",
				"not_evidence": "Delivery evidence will appear here",
				"not_evidence_collected": "The evidence of collection will be seen here",
				"not_evidence_pickup": "Evidence of delivery will be seen here"
			}
		},
		"property": {
			"title": "Property",
			"open_google_maps": "Open in Google Maps",
			"address": "Address",
			"description": "Description",
			"name_property": "Property name",
			"opening_hours": "Scheduled Attetion",
			"weekdays": "Monday to Friday",
			"weekends": "Saturday and Sunday"
		},
		"lockerDetail": {
			"title": "Locker detail",
			"destiny_locker": "Locker name",
			"door_assigned": "Door assigned",
			"maximum_measures": "Maximum Length",
			"sending_type": "Service Type",
			"address_locker": "Address locker"
		},
		"clientDetail": {
			"title": "Client detail",
			"client_name": "Client name",
			"client_phone": "Client phone",
			"client_email": "Client email",
			"notifications_email": "Notifications Email",
			"notifications_push": "Notifications Push"
		},
		"carrierDetail": {
			"title": "Carrier detail",
			"carrier_name": "Carrier name",
			"carrier_code_deliver": "Carrier code",
			"signature_required": "Signature required",
			"logo": "Logo",
			"yes": "Yes",
			"no": "No"
		},
		"order_detail": {
			"title": "Order detail",
			"order_number": "Order Number",
			"tracking": "Tracking number",
			"register_date": "Registration date",
			"otp": "OTP",
			"collected_date": "Collected date",
			"expiration_date": "Expiration date"
		},
		"notify-details": {
			"title": "Notifications",
			"id_notification_package": "Notification ID",
			"type_notification": "Notification Type",
			"send_date": "Send Date",
			"status": "Status",
			"message_type": "Notification Method"
		}
	},

	"timeline": {
		"title": {
			"SCHEDULE": "Order scheduled",
			"ASSIGNED": "Order assigned",
			"IN_LOCKER": "Order in locker",
			"EXPIRED": "Order expired",
			"COLLECTED": "Order delivered",
			"ACTUALIZAR": "Updated Order",
			"PICKUPPACKAGE": "Order picked up",
			"RETURNED": "Order returned",
			"REFUND": "Order returned",
			"DELIVERYPACKAGE": "Order delivered",
			"CANCELED_UNUSED": "Order canceled without use",
			"IN_PROPERTY": "En propiedad"
		},
		"description": {
			"SCHEDULE": "The order has been scheduled",
			"ASSIGNED": "The order has been assigned",
			"IN_LOCKER": "The order has been placed in the locker",
			"EXPIRED": "Oh no, the order has expired",
			"ACTUALIZAR": "The order has been updated",
			"COLLECTED": "The order has been delivered, good job!",
			"PICKUPPACKAGE": "The order has been picked up",
			"RETURNED": "The order has been returned",
			"REFUND": "The order has been returned",
			"DELIVERYPACKAGE": "The order has been delivered",
			"CANCELED_UNUSED": "The order has been canceled without use"
		}
	},
	"unitsPage": {
		"title": "Units",
		"breadcrumb": {
			"company": "Company",
			"property": "Property",
			"residents": "Residents",
			"floor_units": "Floors and Units",
			"units": "Units",
			"historial": "History"
		},
		"alerts": {
			"closeDialog": {
				"title": "Process canceled",
				"subtitle": "You have canceled the process of adding customers to the unit."
			},
			"unitAdded": {
				"title": "Unit Added",
				"subtitle": "Now the users you add will be able to view the unit"
			},
			"unitNotAdded": {
				"title": "Unit not added",
				"subtitle": "The user has not been added. Please check the fields."
			},
			"unitRemoved": {
				"title": "Unit Removed",
				"subtitle": "Users will no longer have access to this unit"
			},
			"error": {
				"title": "Platform Failure",
				"subtitle": "There was an error with the platform, please contact Vivipost"
			},
			"usersAddedToUnit": {
				"title": "Users Added",
				"subtitle": "The selected users now have access to this unit"
			},
			"usersNotAddedToUnit": {
				"title": "Customer not added",
				"subtitle": "The customer has not been added to this unit"
			},
			"unitsWithError": {
				"title": "Some units were not added",
				"subtitle": "Duplicate units were detected. Please check the information before continuing."
			}
		},
		"buttons": {
			"save": "Save",
			"add_units": "Add units",
			"add_unity": "Add unit",
			"add_floor": "Add floor",
			"add_street": "Add street",
			"export": "Export",
			"cancel": "Cancel"
		},
		"cards": {
			"card-1": {
				"title": "Total units",
				"tooltip": "Total number of users since the system started being used.",
				"footer": "Information not available"
			},
			"card-2": {
				"title": "Average users per unit",
				"tooltip": "Clients who pick up orders only once.",
				"footer": "Information not available"
			},
			"card-3": {
				"title": "Active units",
				"tooltip": "Total number of users registered in a unit",
				"footer": "Information not available"
			},
			"card-4": {
				"title": "Inactive units",
				"tooltip": "Units that have no registered users",
				"footer": "Information not available"
			}
		},
		"overloads": {
			"noRows": {
				"title": "There's nothing here....",
				"subtitle": "Here you can view the units."
			},
			"loading": {
				"title": "Loading content..."
			}
		},
		"table": {
			"floor": "Floor",
			"unit": "Unit number",
			"address": "Address",
			"total_user_registered": "Total registered users",
			"total_user_active": "Total active users",
			"packages_delivered_to_the_unit_this_month": "Packages delivered to the unit this month",
			"packages_delivered_to_the_unit_all_time": "Packages delivered to the unit all time",
			"actions": "Actions",
			"unit_code": "Unit code",
			"unit_type": "Unit type",
			"id_status": "Status",
			"register_date": "Registration date",
			"update_date": "Update date"
		},
		"dialog": {
			"dialogToEditUnit": {
				"title": "Update Unit",
				"subtitle": "Here you can update the unit information",
				"buttons": {
					"cancel": "Cancel",
					"update": "Update unit"
				}
			},
			"dialogToAddUnit": {
				"title": "Add Unit",
				"subtitle": "Here you can add the unit",
				"buttons": {
					"cancel": "Cancel",
					"add": "Add unit"
				}
			},
			"dialogToDeleteUnit": {
				"title": "Delete Unit",
				"subtitle": "Here you can delete the unit information",
				"buttons": {
					"cancel": "Cancel",
					"delete": "Delete unit"
				}
			},
			"dialogToUpdateUnit": {
				"title": "Update unit code",
				"subtitle": "Here you can update the unit code",
				"buttons": {
					"cancel": "Cancel",
					"update": "Update unit code"
				}
			}
		},
		"units": {
			"unit": "Unit",
			"placeholder": {
				"unit_number": "Enter the unit",
				"apartment_number": "Enter the apartment number",
				"code": "123456",
				"guests_limit": "123456",
				"floor": "Enter the floor number",
				"street": "Enter the subdivision street"
			},
			"access_code": "Access code",
			"maintenance_payment": "Maintenance payment",
			"guests_limit": "Guest limit",
			"total_people": "People in the unit",
			"usage_type": "Usage type",
			"add_unit": "Add unit",
			"save": "Save",
			"edit": "Edit",
			"delete": "Delete",
			"update_code": "Update code",
			"show_residents": "Show residents",
			"floor": "Floor",
			"street": "Street",
			"guests": "Guests",
			"admins": "Admins",
			"owners": "Owners",
			"units": "Units",
			"yes": "Yes",
			"no": "No"
		},
		"residents": {
			"title": "Add resident to unit",
			"form": {
				"first_name": "First name",
				"last_name": "Last name",
				"email": "Email",
				"phone": "Phone",
				"description": "Description",
				"type_use": "Usage type",
				"type_consumer": "Consumer type"
			},
			"placeholder": {
				"first_name": "Enter first name",
				"last_name": "Enter last name",
				"email": "Enter email",
				"phone": "Enter phone number",
				"description": "Enter a description",
				"type_use": "Usage type",
				"type_consumer": "Consumer type"
			},
			"buttons": {
				"save": "Save",
				"cancel": "Cancel"
			}
		}
	},

	"subsctriptionsPage": {
		"title": "Subscriptions",
		"contentSwitcher": {
			"resume_by_unity": "Summary by unit",
			"log_of_pays": "Payment history",
			"last_pay": "Last payment"
		},
		"table": {
			"id_subscription": "ID",
			"folio": "Folio",
			"client_name": "Client\nname",
			"id_propierty": "Property ID",
			"email": "Email",
			"unit": "Unit",
			"locker_name": "Locker",
			"unit_code": "Unit\ncode",
			"id_status": "Payment status",
			"total": "Total",
			"status": "Status",
			"register_date": "Registration date",
			"cut_off_date": "Cut-off date",
			"folio_number_expiration": "Payment expiration",
			"update_date": "Update date",
			"actions": "Actions",
			"first_init_sesion": "First session start",
			"gross_price_subscription": "Gross price\nof subscription",
			"tax_amount": "Tax\namount",
			"tax_percentage": "Tax\npercentage",
			"net_price_subscription": "Net price\nof subscription",
			"payment_for_management": "Management\nfee"
		},
		"paymentReport": {
			"paymentDate": "Payment date:",
			"orderNumber": "Order number:",
			"totalPayment": "Total payment:",
			"status": "Status",
			"paying_user": "Who is paid?",
			"confirmationDate": "Confirmation date",
			"expirationDate": "Folio expiration date",
			"cutoffDate": "Cut-off date",
			"receiptLink": "Receipt link",
			"total": "Total:",
			"paidWith": "Paid with Stripe",
			"showDetails": "Show details",
			"unitsPaid": "Units paid",
			"billingDetails": "Billing details",
			"grossPrice": "Gross price",
			"taxAmount": "Tax amount",
			"netPrice": "Net price",
			"relatedLinks": "Related links:",
			"printReceipt": "Print receipt"
		},
		"report": {
			"payment_date": "Payment date:",
			"folio_number": "Order number",
			"total": "Total payment:",
			"status": "Status",
			"confirmation_date": "Confirmation date",
			"folio_number_expiration": "Payment expiration",
			"cut_off_date": "Cut-off date",
			"link": "Receipt",
			"showDetail": "View details",
			"package_includes": {
				"title": "Package includes"
			}
		},
		"subscriptionInformation": {
			"title": "Subscription information",
			"propertyName": "Property name:",
			"propertyCode": "Property code:",
			"cutoffDay": "Cut-off day:",
			"cutoffDaySuffix": "of every month",
			"gracePeriod": "Grace period:",
			"requiresCarrierCode": "Requires delivery code?",
			"requiresSignature": "Requires signature?",
			"canExtendPayment": "Can extend payment?",
			"currentUnits": "Current units to be charged:",
			"yes": "Yes",
			"no": "No"
		},
		"paymentInformation": {
			"title": "Payment information",
			"folioNumber": "Folio number:",
			"cutoffDate": "Cut-off date",
			"amountToPay": "Amount to pay:",
			"expirationDate": "Expiration date:",
			"status": "Status:",
			"payButton": "Pay",
			"payHistory": "View payment history",
			"unitSummary": "Charge summary per unit"
		}
	},
	"companyInfo": {
		"title": "Property Information",
		"property": "Property",
		"code": "Code",
		"urbanization_type": "Urbanization Type",
		"urbanization_description": "Urbanization Description",
		"address": "Address",
		"description": "Description"
	},
	"unitInfo": {
		"title": "Unit Information",
		"unit": "Unit",
		"usage_type": "Usage Type",
		"guest_limit": "Guest Limit",
		"registration_date": "Registration Date",
		"access_code": "Access Code"
	},
	"residentsPage": {
		"title": "Residents",
		"breadcrumb": {
			"company": "Company",
			"residents": "Residents",
			"properties": "Properties",
			"units": "Units"
		},
		"cards": {
			"card-1": {
				"title": "Total clients",
				"footer": "Total clients",
				"tooltip": "Total number of registered customers"
			},
			"card-2": {
				"title": "New clients registered this month",
				"footer": "Total clients",
				"tooltip": "Number of new clients registered this month"
			},
			"card-3": {
				"title": "Active clients this month",
				"footer": "Active clients this month",
				"tooltip": "Number of active clients this month"
			},
			"card-4": {
				"title": "Inactive clients this month",
				"footer": "Inactive clients this month",
				"tooltip": "Number of inactive clients this month"
			}
		},
		"buttons": {
			"createUser": "Add Resident"
		},
		"table": {
			"first_name": "First Name",
			"code": "Code",
			"consumer_type": "Rol",
			"main_tlf": "Main Phone",
			"sobriquet": "Alias",
			"initial_access": "Initial access",
			"id_status": "Status",
			"description": "Description",
			"actions": "Actions"
		}
	},
	"uploadUnits": {
		"buttonLabel": "Upload Units",
		"popupTitle": "Import your units data",
		"popupSubtitle": "You can upload a file with your units data. If you don't have a file in the correct format yet, you can download a template",
		"popupLink": "by clicking here.",
		"fileUploader": {
			"link": "Click here",
			"clickHere": " to open your file explorer and select the file to import.",
			"fileSizeLimit": "The file you upload cannot be larger than 10MB."
		},
		"fileUpload": {
			"fileName": "{{this.file.name}}",
			"fileSize": "{{ (this.file.size / 1024 / 1024).toFixed(2) }} MB",
			"progress": "{{this.progress}}%"
		},
		"errors": {
			"fileSizeOver": "It seems the file you are trying to upload is larger than 10MB. Please check and try again.",
			"invalidFileType": "The file type is not valid. Only Excel files (csv or xls extension) are allowed.",
			"invalidHeaders": "The file does not contain the required headers: Name, Last Name, Email, Phone."
		},
		"alert": {
			"text": "Units created",
			"subtitle": "The  units have been created"
		}
	},
	"dialogToAssignUnit": {
		"title": "Assign Client to a Unit",
		"subtitle": "In this modal, you can assign a unit to a client who does not yet have one.",
		"forms": {
			"unit": "Unit",
			"client": "Client"
		},
		"placeholder": {
			"unit": "Select a unit",
			"client": "Select a client"
		},
		"buttons": {
			"cancel": "Cancel",
			"assign": "Assign Unit"
		}
	},
	"initialAccess": {
		"active": "Active",
		"inactive": "Inactive"
	},
	"dialogToUploadUnit": {
		"title": "Import Units",
		"subtitle": "Check that the data for the units you want to enter is correct. This is not a definitive action; you can edit the unit values manually by double-clicking on the unit.",
		"table": {
			"name": "Unit name",
			"code": "Code",
			"location": "Location",
			"reference": "Reference",
			"type": "Unit type",
			"isAccepted": "Status",
			"message": "Message"
		},
		"buttons": {
			"addUnits": "Add units",
			"cancel": "Cancel"
		},
		"error": {
			"title": "An error occurred",
			"subtitle": "The data has not been registered. You will soon see details about why the units were not uploaded.",
			"buttons": {
				"close": "Close"
			}
		}
	},
	"validatePackage": {
		"title": "Validate Packages",
		"infoCard": {
			"title": "Package Validation",
			"description": "Review the package information by comparing the label data with the records in the system.",
			"subTitle": "What does the score mean?",
			"subDescription": "Each field shows a match level that helps you detect errors in the tracking number, recipient, sender, phone, or address before processing or delivering the package."
		},
		"form": {
			"title": "Package Metadata",
			"carrier": {
				"label": "Carrier",
				"placeholder": "Enter the carrier from the label"
			},
			"tracking": {
				"label": "Tracking",
				"placeholder": "Enter the package tracking number"
			},
			"recipient": {
				"label": "Recipient",
				"placeholder": "Enter the client from the label",
				"errorMessage": "This field is required"
			},
			"phone": {
				"label": "Phone",
				"placeholder": "Enter the client's phone number from the label"
			},
			"sender": {
				"label": "Sender",
				"placeholder": "Enter the client's email from the label"
			},
			"address": {
				"label": "Address",
				"placeholder": "Enter the client's address from the label"
			},
			"score": {
				"label": "Score",
				"total": "Total Score"
			}
		},
		"controls": {
			"rotate": "Rotate image",
			"download": "Download image",
			"expand": "View in full screen",
			"prev": "Previous image",
			"next": "Next image"
		},
		"footer": {
			"cancel": "Cancel",
			"validate": "Validate package"
		}
	},
	"ticketsPage": {
		"title": "Tickets",
		"contentSwitcher": {
			"new": "New",
			"process": "In Process",
			"solved": "Solved",
			"archived": "Archived"
		},
		"cards": {
			"new": {
				"title": "New tickets",
				"tooltip": "Tickets that have been created by customers",
				"footer": "Footer ticket"
			},
			"process": {
				"title": "Tickets in progress",
				"tooltip": "Tickets that have started a conversation or have been read",
				"footer": "Footer ticket"
			},
			"solved": {
				"title": "Closed tickets",
				"tooltip": "Tickets that have already been resolved by support",
				"footer": "Footer ticket"
			},
			"total": {
				"title": "Total tickets",
				"tooltip": "Total number of tickets generated",
				"footer": "Footer ticket"
			}
		},
		"table": {
			"common": {
				"status": "Status",
				"subject": "Subject",
				"property": "Property Name",
				"unit": "Unit",
				"id_ticket": "Ticket ID",
				"time_request": "Request Time",
				"last_update": "Last Update",
				"registration_date": "Registration Date",
				"client": "Client",
				"support_name": "Support Name",
				"actions": "Actions"
			},
			"new": {
				"empty": "No new tickets available"
			},
			"process": {
				"empty": "No tickets in process"
			},
			"solved": {
				"empty": "No solved tickets available"
			},
			"archived": {
				"empty": "No archived tickets available"
			}
		},
		"alerts": {
			"deleted": {
				"title": "Ticket Deleted",
				"subtitle": "The ticket was successfully deleted"
			},
			"archived": {
				"title": "Ticket Archived",
				"subtitle": "The ticket was successfully archived"
			},
			"changed": {
				"title": "Subject Changed",
				"subtitle": "The ticket subject was successfully updated"
			},
			"error": {
				"title": "An Error Occurred",
				"subtitle": "The operation could not be completed, please try again"
			}
		},
		"buttons": {
			"export": "Export",
			"filter": "Filter",
			"clear": "Clear",
			"close": "Close",
			"accept": "Accept",
			"cancel": "Cancel"
		},
		"filters": {
			"search_placeholder": "Search by ID, subject or client",
			"date_from": "From",
			"date_to": "To",
			"status": "Filter by status"
		},
		"overlay": {
			"loading": "Loading content...",
			"noRows": {
				"new": {
					"title": "No new tickets",
					"subtitle": "Here you will see tickets that customers have just created"
				},
				"process": {
					"title": "No tickets in progress",
					"subtitle": "Here you will see the tickets that are currently being reviewed"
				},
				"solved": {
					"title": "No solved tickets",
					"subtitle": "Here you will see the tickets that have already been resolved"
				},
				"archived": {
					"title": "No archived tickets",
					"subtitle": "Here you will see the tickets that have been archived"
				}
			}
		}
	},
	"ticketsDetailPage": {
		"breadcrumb": {
			"tickets": "Ticket",
			"current": "Detail"
		},
		"title": "Ticket Detail",
		"conversationWithClient": {
			"starter": "Conversation with",
			"chips": {
				"update": "Refresh"
			},
			"status": {
				"new": "New",
				"solved": "Solved",
				"archived": "Archived",
				"deleted": "Deleted",
				"inProgress": "In Progress"
			},
			"popUpContainer": {
				"closeTicket": "Close Ticket",
				"deleteTicket": "Delete Ticket",
				"reasignTicket": "Reassign Ticket",
				"changeSubject": "Change Subject",
				"archivedTicket": "Archive Ticket"
			},
			"sentText": {
				"placeholder": {
					"text": "Type a message",
					"note": "Type an internal note"
				}
			},
			"buttons": {
				"sendText": "Send",
				"sendNote": "Send Internal Note"
			},
			"alerts": {
				"unauthorized": {
					"title": "You cannot make changes",
					"subtitle": "The ticket has been assigned to another support user"
				},
				"unabledToChat": {
					"title": "Cannot send messages",
					"subtitle": "You do not have permission to send messages to this ticket"
				},
				"unabledToDelete": {
					"title": "Ticket not deleted",
					"subtitle": "You do not have permission to delete this ticket"
				},
				"unabledToArchived": {
					"title": "Ticket not archived",
					"subtitle": "You do not have permission to archive this ticket"
				},
				"subjectNotChanged": {
					"title": "Ticket subject not changed",
					"subtitle": "The ticket subject was not changed because you do not have permission"
				},
				"subjectChanged": {
					"title": "Ticket subject changed",
					"subtitle": "The ticket subject has been successfully changed"
				},
				"notAssigned": {
					"title": "User not assigned to ticket",
					"subtitle": "The ticket has already been assigned once and cannot be reassigned"
				},
				"closed": {
					"title": "Ticket Closed",
					"subtitle": "The ticket has been deleted, it will no longer appear in the list and you will be redirected to the tickets page"
				},
				"deleted": {
					"title": "Ticket Deleted",
					"subtitle": "The ticket has been deleted, it will no longer appear in the list and you will be redirected to the tickets page"
				},
				"assigned": {
					"title": "User assigned to ticket",
					"subtitle": "The ticket has been assigned to the new user and cannot be reassigned"
				},
				"isArchived": {
					"title": "Ticket archived",
					"subtitle": "The ticket has already been archived and cannot be modified"
				}
			}
		},
		"propertyInformation": {
			"title": "Property Information",
			"field": {
				"property": "Property Name",
				"phone": "Phone",
				"week": "Weekday Schedule",
				"weekend": "Weekend Schedule",
				"address": "Address"
			}
		}
	},
	"camerasPage": {
		"title": "Cameras",
		"subtitle": "Select a camera to request a recording",
		"view": {
			"empty": "Your recording will appear here"
		},
		"table": {
			"cam_name": "Camera\nname",
			"type": "Type",
			"format": "Format",
			"function": "Function",
			"fps": "FPS",
			"status": "Status"
		},
		"request": {
			"title": "Request a recording from",
			"note": "Note: this process may take a few minutes"
		},
		"calendar": {
			"title": "Select a date"
		},
		"time": {
			"start": "Select a start time",
			"end": "Select an end time"
		},
		"buttons": {
			"clear": "Clear",
			"cancel": "Cancel",
			"search": "Search recording"
		},
		"records": {
			"title": "Available recordings",
			"table": {
				"id_record": "Record\nID",
				"date_record": "Record\ndate",
				"duration": "Duration",
				"size": "Size",
				"actions": "Actions"
			}
		},
		"overloads": {
			"noRows": {
				"title": "Nothing here yet...",
				"subtitle": "No recordings were found for the selected range."
			},
			"loading": {
				"title": "Loading recordings..."
			}
		},
		"alerts": {
			"searchSuccess": {
				"title": "Recordings found",
				"subtitle": "Recordings were successfully loaded."
			},
			"searchEmpty": {
				"title": "No results",
				"subtitle": "No recordings were found for the selected range."
			},
			"searchError": {
				"title": "Recording search error",
				"subtitle": "An error occurred. Please try again."
			}
		}
	},
	"camerasDetail": {
		"title": "Events of tracking: ",
		"recordWillDisplayed": {
			"title": "Your recording will be displayed here"
		},
		"recordError": {
			"title": "The video could not be played",
			"subtitle": "The recording is not available or there was a problem loading it.",
			"button": "Retry"
		},
		"timePicker": {
			"startTime": "Start Time",
			"endTime": "End Time"
		}
	}
}
